import { Duplicate as DuplicateIcon } from '@/components/chariot-ui';
import React, { PropsWithChildren, useState } from 'react';

import { Tooltip } from '@/components/Tooltip';
import { cn } from '@/utils/classname';
import { copyToClipboard } from '@/utils/copyToClipboard.util';

interface CopyToClipboardProps extends PropsWithChildren {
  hideCopyIcon?: boolean;
  className?: string;
  textToCopy?: string;
  alwaysShowCopyIcon?: boolean;
  iconClassName?: string;
}

export function CopyToClipboard(props: CopyToClipboardProps) {
  const {
    hideCopyIcon,
    children,
    className,
    textToCopy,
    alwaysShowCopyIcon,
    iconClassName,
  } = props;

  const [copied, setCopied] = useState(false);
  const textToCopyFromChildren =
    textToCopy || getTextToCopyFromChildren(children);

  return (
    <div className={cn('group/copy flex items-center', className)}>
      <div className="flex overflow-hidden">{children}</div>
      {!hideCopyIcon && textToCopyFromChildren && (
        <div className="ml-1 flex shrink-0">
          <Tooltip
            title={copied ? 'Copied to Clipboard' : 'Copy value to clipboard'}
          >
            <div>
              <DuplicateIcon
                className={cn(
                  'text-chariot-text-primary cursor-pointer text-[16px]',
                  !alwaysShowCopyIcon &&
                    'opacity-0 group-hover/copy:opacity-100',
                  iconClassName
                )}
                onClick={e => {
                  e.stopPropagation();
                  copyToClipboard(textToCopyFromChildren);
                  setCopied(true);
                  setTimeout(() => setCopied(false), 2000);
                }}
              />
            </div>
          </Tooltip>
        </div>
      )}
    </div>
  );
}

function getTextToCopyFromChildren(children: React.ReactNode): string {
  if (typeof children === 'string') {
    return children.trim();
  }

  if (React.isValidElement(children)) {
    const props = children.props as any;
    if (typeof props?.text === 'string') {
      return props.text.trim();
    }

    if (typeof props?.children === 'object' && Array.isArray(props?.children)) {
      return getTextToCopyFromChildren(props.children[0]);
    }

    return getTextToCopyFromChildren(props?.children);
  }

  return '';
}
